import * as React from "react";
import { CircularProgress, Backdrop, Grid, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { ApiService } from "../../../utils/ApiService";
import { AlgorithmCard } from "../Internalcomponents/AlgorithmCard";

const DashboardCards = (props) => {
  const [familyName, setFamilyName] = useState();

  const [latestDate, setLatestDate] = useState();

  const [cardsData, setCardsData] = useState();
  const [loadopen, setLoadpen] = useState(false);

  const handleExportFile = (param) => {
    props.export_file(param);
  };

  useEffect(() => {
    setFamilyName(props.family);
    var fName = props.family;
    if (fName === "") {
      fName = "30RB";
    }

    setLoadpen(true);

    ApiService("get_family_data", "GET", { family_name: fName })
      .then((response) => {
        setCardsData(response.body.data);
        setLoadpen(false);
      })
      .catch((error) => {
        console.log(error);
        setCardsData(null);
        setLoadpen(false);
      });
  }, [props.family]);

  return (
    <>
      <Box sx={{ padding: 2 }}>
        <Grid container spacing={3} justifyContent="center">
          <AlgorithmCard
            name="Total Units"
            value={cardsData ? cardsData.Count : 0}
          />

          <AlgorithmCard
            name="Raw Data Cleaned"
            value={cardsData ? cardsData.field_status : 0}
            percentage={true}
            totalValue={cardsData ? cardsData.Count : null}
          />

          <AlgorithmCard
            name="L1 Calculation"
            value={cardsData ? cardsData.l1_status : 0}
            percentage={true}
            totalValue={cardsData ? cardsData.Count : null}
          />

          <AlgorithmCard
            name="Leakage Detection"
            value={cardsData ? cardsData.leak_det_status : 0}
            percentage={true}
            totalValue={cardsData ? cardsData.Count : null}
          />

          <AlgorithmCard
            name="Cond Fouling"
            value={cardsData ? cardsData.cond_foul_status : 0}
            percentage={true}
            totalValue={cardsData ? cardsData.Count : null}
          />

          <AlgorithmCard
            name="Cond Foul All Bins"
            value={cardsData ? cardsData.cond_foul_all_bins_status : 0}
            percentage={true}
            totalValue={cardsData ? cardsData.Count : null}
          />
        </Grid>
      </Box>

      <Box sx={{ padding: 1 }}>
        <Grid container spacing={3} justifyContent="center">
          <AlgorithmCard
            name="Cond Foul Trend"
            value={cardsData ? cardsData.cond_foul_trend_status : 0}
            percentage={true}
            totalValue={cardsData ? cardsData.Count : null}
          />

          <AlgorithmCard
            name="Evap Fouling"
            value={cardsData ? cardsData.evap_foul_status : 0}
            percentage={true}
            totalValue={cardsData ? cardsData.Count : null}
          />

          <AlgorithmCard
            name="Thr Aanalysis"
            value={cardsData ? cardsData.thr_analysis_status : 0}
            percentage={true}
            totalValue={cardsData ? cardsData.Count : null}
          />

          <AlgorithmCard
            name="Last Updated"
            value={cardsData ? cardsData.latestDate : 0}
          />
        </Grid>

        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadopen}
        >
          <CircularProgress size="4rem" />
        </Backdrop>
      </Box>
      {/* <Divider sx={{ marginTop: 3, fontWeight: "500" }}>
        Previous Execution Data
      </Divider> */}
    </>
  );
};

export default DashboardCards;
